import React from 'react';
import Button from '../../../../components/molecules/buttons';

interface Props {
    children: React.ReactElement;
    onNavigate?: () => void;
    buttonWidth?: number;
    title: string;
    buttonLabel?: string;
    haveButton?: boolean;
}

function ContentContainer(props: Props) {
  const {
    haveButton, children, title, buttonWidth, buttonLabel, onNavigate,
  } = props;
  return (
    <div className="px-4 px-xl-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="fz-16 fw-bold">{title}</div>
        <div style={haveButton ? { width: buttonWidth } : { display: 'none' }}>
          <Button.Default
            id="viewPaidInvoices"
            type="button"
            label={buttonLabel}
            onClick={onNavigate}
            outline
          />
        </div>
      </div>
      {children}
    </div>
  );
}

ContentContainer.defaultProps = {
  onNavigate: () => null,
  buttonWidth: 200,
  buttonLabel: '',
  haveButton: true,
};

export default ContentContainer;
